import React from 'react';

export default function UnAuthorisedPage() {
  return (
    <div style={{padding:'50px', textAlign:'center'}}>
    <h2>Please sign-in and re-select to continue</h2>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/UnAuthorisedPage.js